"use client";
import { jsx } from "react/jsx-runtime";
import { EnvironmentContext } from "./EnvironmentContext.js";
const EnvironmentProvider = ({
  variables,
  setVariable,
  children
}) => /* @__PURE__ */ jsx(EnvironmentContext.Provider, { value: { variables, setVariable }, children });
export {
  EnvironmentProvider
};
